export const MESSAGES = {
  'minlength': 'Campo inválido',
  'required': 'Campo obrigatório',
  'email.invalid': 'Email inválido',
  'confirm.password.invalid': 'Senhas não conferem',
  'person.invalid': 'Documento inválido',
  'zipcode.invalid': 'CEP inválido',
  'login.invalid': 'Login inválido'
}